import React, { Fragment, useContext, useEffect } from "react";
import { CommonService } from "../../services/common/common.service";
import { useTranslation } from "react-i18next";
import HeaderComponent from "../../components/header/header.component";
import { GlobalContext } from "../../store";
import { ContentLayout } from "../../layouts/content/content.layout";
import PagesHeadComponent from "../../components/pages-head-component/pages-head.component";
import ReusableComponentsComponent from "../../modules/reusable-components/reusable-components.component";

export default function ReusableComponentsPage() {
  const { t } = useTranslation();
  const commonService: CommonService = new CommonService();
  const { setPageTitle } = useContext(GlobalContext);

  useEffect(() => {
    setTimeout(() => {
      commonService.setTitle(t("PAGE_META_TITLES.REUSABLE_UI_COMPONENTS"));
      setPageTitle(t("PAGE_META_TITLES.REUSABLE_UI_COMPONENTS"));
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Fragment>
      <HeaderComponent />
      <ContentLayout>
        <PagesHeadComponent
          title={t("PAGES_HEAD.REUSABLE_UI_COMPONENTS")}
          subTitle={t("PAGES_HEAD.REUSABLE_UI_COMPONENTS_SUB_TITLE")}
        />
        <ReusableComponentsComponent />
      </ContentLayout>
    </Fragment>
  );
}
